module.exports = __webpack_public_path__ + "img/login-bg.e6290f6c.jpg";